import { useCheckPermissions } from '@/shared';
import { SaveModeloProductos } from '../../shared/saveModeloProducto';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CreateModeloProductosPageInterface {}

const CreateModeloProductosPage: React.FC<CreateModeloProductosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_modelo);
  return <SaveModeloProductos titlePage="Crear Modelo productos" />;
};

export default CreateModeloProductosPage;
